import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-connected-email-redirect',
  templateUrl: './connected-email-redirect.component.html',
  styleUrls: ['./connected-email-redirect.component.scss']
})
export class ConnectedEmailRedirectComponent implements OnInit {

  error: string = null;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.error = null;
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      let code: string = queryParams['code'];
      let error: string = queryParams['error'];
      let provider: string = queryParams['state'];

      if (code) {
        localStorage.setItem('ecodocs_connected_email', code);
        window.close();
      } else if (error) {
        this.error = error;
      }
    });

  }

}
